// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { PoType } from "../../types"

// Utils
import { useApi } from "utils"

export function usePoDetail(id: string) {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<PoType | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get("/purchaseorder/detailpo", {
      params: { po_id: id }
    }).then((res: SuccessFetch<{
      payload: {
        datapo: {
          address: string
          location_id: number
          trx_code: string
          vendor_id: number
          vendor_name: string
        }
      }
    }>) => {
      // Vars
      const result = res.data.payload

      setData({
        approve_by: 0,
        approve_status: 0,
        amount: 0,
        coa_id: "",
        memo: "",
        no_cheque: "",
        purchase_order_id: parseInt(id),
        transaction_date: "",
        trx_code: "",
        datapo: {
          ...result.datapo,
          location_id: result.datapo.location_id.toString(),
          vendor_id: result.datapo.vendor_id.toString()
        }
      })
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}